import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useResourceSingle } from './useResourceSingle';
import { MAP_JSON_ENDPOINTS } from 'constants/map-json-endpoints';
import * as ProjectActions from 'store/project/projectSlice';
import * as OrderActions from 'store/order/orderSlice';

export const useResource = () => {
  const {filterProjectsTypes, filterProjectsDetails} = useResourceSingle();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isSingle, setIsSingle] = useState(false);

  const success = (data) => {
    const {
      projectsTypes,
      projectsDetails,
      payments
    } = data;
    const filteredProjectsTypes = filterProjectsTypes(projectsTypes);
    const filteredProjectsDetails = filterProjectsDetails(projectsDetails);

    dispatch(OrderActions.checkAndUpdateIfUserProfileExists({}));
    dispatch(OrderActions.checkAndUpdateIfOrderExists({}));

    dispatch(ProjectActions.setProjectsTypes(filteredProjectsTypes));
    dispatch(ProjectActions.setProjectsDetails(filteredProjectsDetails));
    dispatch(ProjectActions.setPayments(payments));

    setIsSingle(filteredProjectsTypes.length === 1);
    setIsLoading(false);
    setIsLoaded(true);
  };

  const failure = (data) => {
    console.error(data.message);
    setIsSingle(false);
    setIsLoading(false);
    setIsLoaded(false);
  };

  useEffect(() => {
    fetch(MAP_JSON_ENDPOINTS[process.env.REACT_APP_ENV])
      .then(data => data.json())
      .then(data => success(data))
      .catch((e) => failure(e))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [
    isLoading,
    isLoaded,
    isSingle,
  ];
}
